module.exports = __webpack_public_path__ + "static/media/after_1.23026db8.jpg";